<template>
  <v-card flat width="100%">
    <v-card-title>
      REF: {{ InfoArticulo({ articulo: Articulo, label: `Codigo` }) }}
      <span class="d-flex ml-3">
        <v-img
          :src="`${domoapi2_img}Marca-deco/${InfoArticulo({
            articulo: Articulo,
            label: `Marca`,
          })}/Alto-30?i=${updateImg}&Cia=15`"
          class="img_art"
        ></v-img>
      </span>
      <pagArt :codArt="InfoArticulo({ articulo: Articulo, label: `Codigo` })" />
    </v-card-title>
    <v-card-text class="mt-n3">
      <div v-html="nombreArt(n - 1)" v-for="n in 1" :key="n"></div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import pagArt from "../pagArt";
export default {
  data() {
    return {
      updateImg: Math.floor(Math.random() * 100),
    };
  },
  components: {
    pagArt,
  },
  computed: {
    ...mapState(["Articulo", "domoapi2_img"]),
    nombreArt: () => {
      return function (pos) {
        if (this.Articulo) {
          var nb = this.Articulo.map((x) => x.Detalle[pos]);
          return nb.toString();
        }
      };
    },
    InfoArticulo: function () {
      return function ({ articulo, label }) {
        if (articulo) {
          const infoArt = articulo.map((x) => x[label]);
          return infoArt[0];
        }
      };
    },
  },
};
</script>

<style scoped>
.img_art {
  max-width: 100%;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
